import React from "react";
import { InlineEditor } from "@hid-galaxy-ui/galaxy-react";
import IToolBarConfig from "@hid-galaxy-ui/galaxy-react/components/InlineEditor/IToolbarConfig";

export const defaultRichTextToolBarConfig: IToolBarConfig = {
  headingConfig: {
    isDisplayHeading: true,
    headings: [false, 1, 2, 3, 4, 5, 6],
  },
  fontStyleConfig: {
    isDisplayBold: true,
    isDisplayItalic: true,
    isDisplayUnderline: true,
    isDisplayStrike: true,
  },
  indentConfig: {
    isDisplayOrdered: true,
    isDisplayBullet: true,
    isDisplayIndent: false,
  },
  colorConfig: {
    isDisplayBackground: false,
    isDisplayColor: false,
  },
  alignmentConfig: {
    isDisplayJustify: false,
    isDisplayCenter: false,
    isDisplayRight: false,
  },
  miscConfig: {
    isDisplayImage: false,
    isDisplayLink: false,
    isDisplayCodeblock: false,
    isDisplayBlockquote: false,
  },
  buttonConfig: {
    buttonLabel: "",
    displayPostButton: false,
    isRequired: false,
  },
};

type Props = {
  id: string;
  value: string;
  /**
   * Store the value exactly as received. Trimming, normalizing or rejecting it
   * here makes the controlled editor reset mid-paste; sanitize on save instead
   * (see `sanitizeRichText`) and enforce length limits by blocking save.
   */
  onChange: (value: string) => void;
  placeholder?: string;
  toolBarConfig?: IToolBarConfig;
  disabled?: boolean;
};

const RichTextEditor: React.FC<Props> = ({
  id,
  value,
  onChange,
  placeholder,
  toolBarConfig = defaultRichTextToolBarConfig,
  disabled,
}) => (
  <InlineEditor
    id={id}
    placeholder={placeholder}
    toolBarConfig={toolBarConfig}
    editorData={value}
    handleOnChange={onChange}
    {...(disabled !== undefined ? { disabled } : {})}
  />
);

export default RichTextEditor;
